<div class="simulation-view-wrapper">
  <div
    class="simulation-view-actions-shell d-flex flex-column shadow-sm rounded-2 border cursor-pointer"
  >
    <ng-container
      *hasPermissionAny="[
        Permissions.RCS_Warnings_Lv_Write,
        Permissions.RCS_Warnings_Hr_Write,
        Permissions.RCS_Warnings_Hs_Write,
        Permissions.RCS_Warnings_Sw_Write,
      ]"
    >
      <app-map-navigation-item>
        <span
          class="rb-ic rb-ic-screw-hexagon-head fs-2xl hover-effect p-2"
          [class.sel-menu-item]="isHexagonWarningCreationVisible"
          [class.rounded-top-2]="isHexagonWarningCreationVisible"
          (click)="toggleHexagonWarning.emit()"
          placement="start"
          ngbTooltip="Create area warnings"
          tooltipClass="custom-tooltip"
          [openDelay]="1000"
          data-cy="enableSimulateAreaWarningMode"
        >
        </span>
      </app-map-navigation-item>
    </ng-container>
    <span class="map-navigation-item-divider"></span>
    <ng-container
      *hasPermissionAny="[
        Permissions.RCS_Warnings_Bdv_Write,
        Permissions.RCS_Warnings_Tl_Write,
        Permissions.RCS_Warnings_Va_Write,
        Permissions.RCS_Warnings_Cs_Write,
        Permissions.RCS_Warnings_Pr_Write,
        Permissions.RCS_Warnings_Wwd_Write,
        Permissions.RCS_Warnings_Ior_Write,
        Permissions.RCS_Warnings_Al_Write,
        Permissions.RCS_Warnings_Bl_Write,
        Permissions.RCS_Warnings_Sv_Write,
        Permissions.RCS_Warnings_Tjt_Write,
      ]"
    >
      <app-map-navigation-item>
        <span class="map-navigation-item-divider"></span>
        <span
          class="rb-ic rb-ic-road fs-2xl hover-effect p-2"
          [class.sel-menu-item]="isRoadWarningCreationVisible"
          (click)="toggleRoadWarning.emit()"
          placement="start"
          ngbTooltip="Create road warnings"
          tooltipClass="custom-tooltip"
          [openDelay]="1000"
          data-cy="enableSimulateRoadWarningMode"
        >
        </span>
      </app-map-navigation-item>
    </ng-container>
    <span class="map-navigation-item-divider"></span>
    <ng-container
      *hasPermissionAny="[
        Permissions.RCS_Warnings_Va_Write,
        Permissions.RCS_Warnings_Bdv_Write,
        Permissions.RCS_Warnings_Tl_Write,
        Permissions.RCS_Warnings_Cs_Write,
        Permissions.RCS_Warnings_Lv_Write,
        Permissions.RCS_Warnings_Hr_Write,
        Permissions.RCS_Warnings_Hs_Write,
        Permissions.RCS_Warnings_Sw_Write,
        Permissions.RCS_Warnings_Pr_Write,
        Permissions.RCS_Warnings_Wwd_Write,
        Permissions.RCS_Warnings_Ior_Write,
        Permissions.RCS_Warnings_Al_Write,
        Permissions.RCS_Warnings_Bl_Write,
        Permissions.RCS_Warnings_Sv_Write,
        Permissions.RCS_Warnings_Tjt_Write,
      ]"
    >
      <ng-container *ngIf="!isSimulationEditorVisible">
        <app-simulation-view-actions-remove-simulations />
        <span class="map-navigation-item-divider"></span>
      </ng-container>
    </ng-container>

    <ng-container
      *hasPermissionAny="[
        Permissions.RCS_Warnings_Va_Write,
        Permissions.RCS_Warnings_Bdv_Write,
        Permissions.RCS_Warnings_Tl_Write,
        Permissions.RCS_Warnings_Cs_Write,
        Permissions.RCS_Warnings_Lv_Write,
        Permissions.RCS_Warnings_Hr_Write,
        Permissions.RCS_Warnings_Hs_Write,
        Permissions.RCS_Warnings_Sw_Write,
        Permissions.RCS_Warnings_Pr_Write,
        Permissions.RCS_Warnings_Wwd_Write,
        Permissions.RCS_Warnings_Ior_Write,
        Permissions.RCS_Warnings_Al_Write,
        Permissions.RCS_Warnings_Bl_Write,
        Permissions.RCS_Warnings_Sv_Write,
        Permissions.RCS_Warnings_Tjt_Write,
      ]"
    >
      <app-map-navigation-item>
        <div
          class="editor-callout-wrapper"
          [class.editor-callout-visible]="highlightNewEditor && !isSimulationEditorVisible"
        >
          <span
            class="rb-ic rb-ic-edit fs-2xl hover-effect p-2"
            [class.sel-menu-item]="isSimulationEditorVisible"
            [class.rounded-bottom-2]="isSimulationEditorVisible"
            [class.new-feature-highlight]="highlightNewEditor && !isSimulationEditorVisible"
            (click)="toggleEditor.emit()"
            placement="start"
            ngbTooltip="Open Simulation Editor"
            tooltipClass="custom-tooltip"
            [openDelay]="1000"
          >
          </span>
          <span *ngIf="highlightNewEditor && !isSimulationEditorVisible" class="new-editor-badge"
            >NEW</span
          >
          <span
            *ngIf="highlightNewEditor && !isSimulationEditorVisible"
            class="new-editor-arrow"
            aria-hidden="true"
          ></span>
        </div>
      </app-map-navigation-item>
    </ng-container>
  </div>
</div>
